<div class="campaign-container redeemed-border cursor-pointer">
  <img [campaignImage]="campaignEntitlement.CampaignId" alt="" class="campaign-img" />

  <div class="campaign-details">
    <div class="font-size-12">{{ campaignEntitlement.CampaignName }}</div>
    <ng-container *ngIf="voucherEntitlement.RedemptionDate; else showExpiry">
      <div class="font-size-12 text-danger">
        {{ 'fgbcl.campaign.claimed' | translate }}
        {{ voucherEntitlement.RedemptionDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
      </div>
    </ng-container>
    <ng-template #showExpiry>
      <ng-container *ngIf="!campaignEntitlement.Claimed || isVoucher">
        <div class="campaign-list-item-expiry-date font-size-12">
          {{ 'offer.expired' | translate }} {{ expiryDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
